import './App.css';
import {HashRouter as Router, Routes, Route, Navigate} from "react-router-dom";
import AboutUs from './components/AboutUs/AboutUs';
import ContactUs from './components/ContactUs/ContactUs';
import Filter from './components/Home_and_Filter/Filter';
import Home from './components/Home_and_Filter/Home';
import Navbar from './components/Navbar/Navbar';
import NavbarMobile from './components/Navbar/NavbarMobile';
import OurMission from './components/OurMission/OurMission';
import PrivacyPage from './components/PrivacyPage/PrivacyPage';
import ProductPage from './components/ProductPage/ProductPage';
import SideMenu from './components/SideMenu/SideMenu';
import WorkWithUs from './components/ContactUs/WorkWithUs';

export default function App() {
  return (
      <Router>
        <main id="app">
          <header id="navbarContainer">
            <Navbar/>
          </header>
          <aside id="sidemenu">
            <SideMenu/>
          </aside>
          <header id="navbarMobileContainer">
            <NavbarMobile/>
          </header>
          <main id="main">
            <Routes>
              <Route path="*" element={<Navigate to={"/"}/>}/>
              <Route path="/" element={<AboutUs/>}/>
              <Route path="/home" element={<Home/>}/>
              <Route path="/filter/:query" element={<Filter/>}/>
              <Route path="/product/:id" element={<ProductPage/>}/>
              <Route path="/ourmission" element={<OurMission/>}/>
              <Route path="/privacypage" element={<PrivacyPage/>}/>
              <Route path="/contactus" element={<ContactUs/>}/>
              <Route path="/workwithus" element={<WorkWithUs/>}/>
            </Routes>
          </main>
        </main>
      </Router>
  );
}